<template>
  <div class="pack">
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    showHeader: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style lang="scss" scoped>
.pack {
  background-color: $white;
  border-radius: 4px;
  border: 1px solid $br3;
  padding: 16px;
}
</style>